import React, { useEffect, useState } from 'react';
import { Alert, Descriptions, Space, Spin } from 'antd';
import InformacionUbicaciones from './InformacionUbicaciones';
import api from '../../../axiosConfig';

export default function ResumenGeografia({ authorizationId, historica, snapshot }) {
  const [contexto, setContexto] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let vigente = true; setContexto(null); setError('');
    if (historica || !authorizationId) return;
    api.get('/autorizaciones-geografia/contexto', { params: { autorizacion_id: authorizationId } })
      .then(({data}) => { if (vigente) setContexto(data); })
      .catch(() => { if (vigente) setError('No se pudo consultar la configuración geográfica.'); });
    return () => { vigente = false; };
  }, [authorizationId, historica]);
  const data = historica ? snapshot : contexto?.snapshot;
  if (error) return <Alert type="warning" message={error} />;
  if (!historica && authorizationId && !contexto) return <Spin />;
  if (!data?.version) return <Alert type="info" message={historica ? 'Esta versión no incluye la configuración de ubicaciones permitidas.' : 'Configure las ubicaciones permitidas antes de programar nuevos traslados.'} />;
  const nombres = (ids, tipo) => ids.map(id => data.etiquetas?.[tipo]?.[id] || `ID ${id}`).join(', ');
  return <>
    {!historica && !contexto?.configurada && <Alert type="warning" message="Revise las ubicaciones permitidas: cambió el cliente o sus reglas de ubicación." />}
    <Descriptions title={<Space>Origen y destino del traslado<InformacionUbicaciones caso={data.caso} historica={historica || !contexto?.configurada} /></Space>} column={1} bordered size="small" style={{ marginBottom: 16 }}>
      {['origen', 'destino'].map(lado => { const a = data.ambitos?.[lado]; return a && <Descriptions.Item key={lado} label={lado === 'origen' ? 'Datos de origen' : 'Datos de destino'}>
        {nombres(a.departamentos, 'departamentos')} · {a.modo === 'todas' ? 'Todas sus ciudades' : nombres(a.ciudades, 'ciudades')}
        {' · Lugar inicial: '}{a.punto.nombre || ({pendiente:'Pendiente',sin_destino:'Sin Destino',domicilio:'Domicilio'})[a.punto.tipo] || a.punto.tipo}
      </Descriptions.Item>; })}
    </Descriptions>
  </>;
}
